let $formationFamilyFilter = $('#is-formation-family-filter');
let $formationLevelFilter = $('#is-formation-level-filter');

export default {
  load() {
    let _self = this;

    if (!$formationFamilyFilter.length || !$formationLevelFilter.length) {
      return;
    }

    $formationFamilyFilter.on('change', function () {
      if ($(this).val()) {
        _self._urlParam('family', $(this).val());
      } else {
        _self._removeParam('family');
      }
    });

    $formationLevelFilter.on('change', function() {
      if ($(this).val()) {
        _self._urlParam('level', $(this).val());
      } else {
        _self._removeParam('level');
      }
    })
  },
  _urlParam(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    let kvp = document.location.search.substr(1).split('&');
    if (kvp === '') {
      document.location.search = '?' + key + '=' + value;
    }
    else {
      let i = kvp.length; let x; while (i--) {
        x = kvp[i].split('=');

        if (x[0] === key) {
          x[1] = value;
          kvp[i] = x.join('=');
          break;
        }
      }

      if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

      //this will reload the page, it's likely better to store this until finished
      document.location.search = kvp.join('&');
    }
  },
  _removeParam(key) {
    let rtn = '';
    let param = '';
    let params_arr = [];
    let queryString = (document.location.search.indexOf('?') !== -1) ? document.location.search.split('?')[1] : '';

    if (queryString !== '') {
      rtn = document.location.search.split('?')[0];

      params_arr = queryString.split('&');

      for (let i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split('=')[0];

        if (param === key) {
          params_arr.splice(i, 1);
        }
      }

      rtn = rtn + (params_arr.join('&') !== '' ? '?' + params_arr.join('&') : '');
    }

    document.location.search = rtn;
  },
}



// WEBPACK FOOTER //
// ./scripts/util/searchInFormationType.js